// extracted by mini-css-extract-plugin
export default {"continer":"Search_continer__NvyFB","item_continer":"Search_item_continer__DI7DJ","box":"Search_box__7FTy+","img_box":"Search_img_box__Esxxp","not_found":"Search_not_found__9oOx1"};